import { render, staticRenderFns } from "./I4ProIntegrationContent.vue?vue&type=template&id=b991980c&scoped=true"
import script from "./I4ProIntegrationContent.vue?vue&type=script&lang=js"
export * from "./I4ProIntegrationContent.vue?vue&type=script&lang=js"
import style0 from "./I4ProIntegrationContent.vue?vue&type=style&index=0&id=b991980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b991980c",
  null
  
)

export default component.exports